"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var material_1 = require("@mui/material");
var Component = function (p) {
    return (Preact.h(Box_1.default, { sx: {
            backgroundColor: p.compatible ? 'background.default' : 'transparent',
            p: '12px',
            borderRadius: '8px',
            alignItems: 'center',
            width: {
                xs: p.cardType === 'text' ? '149px' : '156px',
                md: '198px',
            },
            height: {
                xs: '150px',
                md: p.cardType === 'text' ? '60px' : '150px',
            },
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: p.cardType === 'text' ? 'center' : 'space-around',
            border: p.compatible ? '1px solid' : '1px dashed',
            borderColor: p.selected ? 'primary.main' : (0, material_1.alpha)('#040406DE', 0.12),
        } },
        p.cardType === 'image' && p.colour && (Preact.h(Box_1.default, { width: "50px", height: "50px", bgcolor: p.colour })),
        Preact.h(Typography_1.default, { variant: "body1" }, p.optionText)));
};
exports.Component = Component;
